import YoutubeLoader from "./../elements/YoutubeLoader"
import {initElements} from "../define/shared"

const youtube = new YoutubeLoader()

export default function initVideoBlock() {
    initElements(".wa-block.video", videoBlock => {

        const videoEl = videoBlock.querySelector('.videoContent'),
            url = videoEl.dataset.url,
            playButton = videoBlock.querySelector('.playButton')

        let videoPlayer = videoEl.querySelector('.videoContent-player'),
            player = null

        youtube.api(api => {
            player = new api.Player(videoPlayer.id, {
                videoId: youtube.parseVideoID(url),
                playerVars: {
                    autoplay: playButton ? 0 : 1,
                    controls: playButton ? 1 : 0,
                    autohide: 1,
                    showinfo: 0,
                    rel: 0,
                    modestbranding: 1
                },
                events: {
                    onReady: () => {
                        player.mute()
                        if (!playButton) {
                            adjustBackgroundVideoAR()
                            player.playVideo()
                        }
                    },
                    onStateChange: event => {
                        if (event.data === YT.PlayerState.ENDED) {
                            player.playVideo()
                        }
                    },
                },
            })
        })

        if (playButton) {
            playButton.addEventListener('click', () => {
                player.playVideo()
                videoBlock.classList.add('is--playing')
                player.unMute()
            })
        } else {
            setInterval(adjustBackgroundVideoAR, 500)
            window.addEventListener('resize', adjustBackgroundVideoAR)
        }


        function adjustBackgroundVideoAR() {
            const iframe = videoEl.querySelector('iframe')

            if (!iframe) {
                return
            }

            let slideRatio = videoEl.offsetWidth / videoEl.offsetHeight,
                diff = Math.abs((16 / 9) - slideRatio)
            iframe.style.transform = `scale(${1 + diff})`
        }

    })
}
